import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateLocationNameMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  name: Types.Scalars['String']['input'];
  phone?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateLocationNameMutation = { __typename?: 'mutation_root', update_locations?: { __typename?: 'locations_mutation_response', affected_rows: number } | null };


export const UpdateLocationNameDocument = gql`
    mutation updateLocationName($id: bigint!, $name: String!, $phone: String) {
  update_locations(where: {id: {_eq: $id}}, _set: {name: $name, phone: $phone}) {
    affected_rows
  }
}
    `;
export type UpdateLocationNameMutationFn = Apollo.MutationFunction<UpdateLocationNameMutation, UpdateLocationNameMutationVariables>;

/**
 * __useUpdateLocationNameMutation__
 *
 * To run a mutation, you first call `useUpdateLocationNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationNameMutation, { data, loading, error }] = useUpdateLocationNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUpdateLocationNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationNameMutation, UpdateLocationNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationNameMutation, UpdateLocationNameMutationVariables>(UpdateLocationNameDocument, options);
      }
export type UpdateLocationNameMutationHookResult = ReturnType<typeof useUpdateLocationNameMutation>;
export type UpdateLocationNameMutationResult = Apollo.MutationResult<UpdateLocationNameMutation>;
export type UpdateLocationNameMutationOptions = Apollo.BaseMutationOptions<UpdateLocationNameMutation, UpdateLocationNameMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/updateLocationName.mutation.gql}
 */
export async function updateLocationName(
  variables: UpdateLocationNameMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateLocationNameMutation['update_locations']>
export async function updateLocationName(
  variables: UpdateLocationNameMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateLocationNameMutation>
export async function updateLocationName(
  variables: UpdateLocationNameMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateLocationNameMutation['update_locations'] | UpdateLocationNameMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateLocationNameMutation>(
    UpdateLocationNameDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_locations
}